<template>
  <div
    id="app"
    ref="print"
    style="
      width: 794px;
      height: 1123px;
      padding: 0;
      margin: 0;
      font-family: 宋体;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
    "
  >
    <div>
      <div
        style="
          height: 115px;
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
        "
      >
        <img
          src="./img/jf_logo.png"
          alt=""
          style="padding: 10px; height: 85px"
        />
        <div
          style="
            display: flex;
            font-size: 25px;
            color: #108ee9;
            padding-bottom: 10px;
            font-weight: bold;
          "
        >
          捷丰林合工业设备（上海）有限公司
        </div>
      </div>

      <div
        style="
          width: 100%;
          font-size: 24px;
          height: 30px;
          padding-left: 30px;
          padding-top: 30px;
        "
        class="titleText"
      >
        <span style="font-weight: bold">{{ form.code }}-{{ form.brand }}</span
        >&nbsp;{{ form.model }}
      </div>
      <div
        style="
          width: 100%;
          font-size: 24px;
          font-weight: bold;
          height: 30px;
          text-align: right;
          padding-top: 30px;
        "
        class="titleText"
      >
        价格&nbsp;&nbsp;登入后可查询
      </div>

      <div
        style="
          display: flex;
          padding: 50px 0 30px 30px;
          justify-content: space-between;
        "
      >
        <div style="width: 440px; height: 410px">
          <img
            v-for="(item, index) in imgs.slice(0, 4)"
            :key="index"
            :src="item"
            alt=""
            style="
              width: 213px;
              height: 150px;
              object-fit: cover;
              padding: 20px 3px;
            "
          />
        </div>

        <div style="padding-left: 15px; height: 410px">
          <table style="width: 280px">
            <tr>
              <td style="font-weight: bold">车辆参数</td>
              <td></td>
            </tr>
            <tr>
              <td>负载能力</td>
              <td style="text-align: right">{{ asset.载重能力 }}</td>
            </tr>
            <tr>
              <td>提升高度</td>
              <td style="text-align: right">{{ asset.货叉最大升高 }}</td>
            </tr>
            <tr>
              <td>叉车回落高度</td>
              <td style="text-align: right">{{ asset.叉车回落高度 }}</td>
            </tr>
            <tr>
              <td>阀路</td>
              <td style="text-align: right">{{ asset.阀路 }}</td>
            </tr>
            <tr>
              <td>动力方式</td>
              <td style="text-align: right">{{ asset.动力方式 }}</td>
            </tr>
            <tr>
              <td>生产年份</td>
              <td style="text-align: right">{{ form.factoryDate }}</td>
            </tr>
            <tr>
              <td>叉车自重</td>
              <td style="text-align: right">{{ asset.叉车自重 }}</td>
            </tr>
            <tr>
              <td>电池情况</td>
              <td style="text-align: right">{{ asset.电池情况 }}</td>
            </tr>
          </table>
          <br />
          <br />
          <table style="width: 280px">
            <tr>
              <td style="font-weight: bold">车辆属性</td>
              <td></td>
            </tr>
            <tr>
              <td>属具类型</td>
              <td style="text-align: right">{{ asset.属具类型 }}</td>
            </tr>
            <tr>
              <td>车辆类型</td>
              <td style="text-align: right">{{ asset.车辆类型 }}</td>
            </tr>
            <tr>
              <td>门架类型</td>
              <td style="text-align: right">{{ asset.门架类型 }}</td>
            </tr>
            <tr>
              <td>车架号</td>
              <td style="text-align: right">{{ form.code }}</td>
            </tr>
            <tr>
              <td>工作小时数</td>
              <td style="text-align: right">{{ asset.购入时工时 }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div style="display: flex; margin-top: 30px">
      <div
        style="width: 200px; height: 200px; padding-left: 30px; font-size: 12px"
      >
        <div style="padding: 10px 0; padding-top: 20px">
          捷丰林合工业设备(上海)有限公司
        </div>

        <div style="padding: 10px 0">
          江苏省太仓市陆渡镇江南路81号院内丰田叉车
        </div>

        <div style="padding: 10px 0">13504428433 18616078111</div>

        <div style="padding: 10px 0">www.jfrental.com</div>
      </div>

      <div style="margin-top: 20px; padding: 0 15px; flex: 7">
        <img
          src="./img/zhongchangqi.png"
          alt=""
          style="width: 100%; height: 180px"
        />
      </div>
    </div>
    <div
      style="
        margin-bottom: 30px;
        margin-top: 50px;
        padding: 25px 60px;
        height: 80px;
        display: flex;
        justify-content: center;
      "
    >
      <img
        src="./img/touminglogo.png"
        alt=""
        style="width: 300px; height: 80px"
      />
    </div>
  </div>
</template>

<script>
const uploadConfig = {
  Bucket: "upload-attch-1256082024",
  Region: "ap-beijing",
  SecretId: "AKIDY1KYbXeO9j9OJ8sKg8R4iEYkcN0UeslH",
  SecretKey: "iWEpDTGxXzFJB0e5KNRfkDj9MNCqdJqH",
  appName: "jf",
};
function formatDate(date) {
  var year = date.getFullYear();
  // Months are zero based, so we need to add 1
  var month = (1 + date.getMonth()).toString();
  month = month.length > 1 ? month : "0" + month;
  // Same with days
  var day = date.getDate().toString();
  day = day.length > 1 ? day : "0" + day;
  return year + "-" + month + "-" + day;
}
import axios from "axios";
import COS from "cos-js-sdk-v5";
export default {
  components: {},
  data() {
    return {
      params: {
        id: "",
        customerCompany: "",
        tableName: "",
      },
      form: {},
      asset: {},
      imgs: [],
      quotation: {},
      report: {},
      nowTime: formatDate(new Date()),
      saleInfo: {},
      jfInfo: {},
    };
  },
  mounted() {
    // const _this = this;
    // var queryString = window.location.search;
    // // 去除开头的?
    // if (queryString.startsWith("?")) {
    //   queryString = queryString.slice(1);
    // }
    // queryString.split("&").forEach(function (pair) {
    //   var kv = pair.split("=");
    //   _this.params[kv[0]] = kv[1] || "";
    // });
    // if (this.params.customerCompany) {
    //   this.params.customerCompany = decodeURI(this.params.customerCompany);
    // }
    // this.refreshData();
  },
  methods: {
    async print(e) {
      console.log(e, "eee");
      this.params = {
        id: e.assetID,
        customerCompany: e.customerCompany,
        tableName: e.tableName,
      };
      await this.refreshData();
      this.$print(this.$refs.print);
    },
    async refreshData() {
      this.jfInfo = await this.getData("1", "platform_companyinfor");
      this.form = await this.getData(this.params.id, this.params.tableName);
      this.form.assetConfig.split(";").forEach((item) => {
        const e = item.split(":");
        this.asset[e[0]] = e[1];
      });
      this.imgs = await this.getImgByID("basic/", this.params.id);
      // this.quotation = await this.getData(this.params.recordID, 'jf_web_quotation')
      // this.report = JSON.parse(this.quotation.forliftList).filter(item => item.assetCode == this.form.code)[0]
      this.saleInfo = await this.getData(
        this.quotation.salePersonID,
        "jf_web_sales_buyer"
      );
    },
    // 获取叉车属具
    async getData(id, tableName) {
      return new Promise((resolve, reject) => {
        axios
          .post(this.$apiUrl + "/api/general/querySingle", {
            tableName: tableName,
            id: id,
          })
          .then((res) => {
            resolve(res.data.data);
          });
      });
    },
    // 获取图片函数
    async getImgByID(addr, id) {
      return new Promise((resolve, reject) => {
        let imgs = [];
        const cos = new COS({
          SecretId: uploadConfig.SecretId,
          SecretKey: uploadConfig.SecretKey,
        });
        cos.getBucket(
          {
            Bucket: uploadConfig.Bucket /* 填入您自己的存储桶，必须字段 */,
            Region:
              uploadConfig.Region /* 存储桶所在地域，例如ap-beijing，必须字段 */,
            Prefix:
              `${uploadConfig.appName}/` +
              addr +
              id /* Prefix表示列出的object的key以prefix开始，非必须 */,
          },
          function (err, data) {
            data.Contents.forEach((obj, i) => {
              imgs[i] =
                `https://${uploadConfig.Bucket}.cos.${uploadConfig.Region}.myqcloud.com/` +
                obj.Key;
            });
            resolve(imgs);
          }
        );
      });
    },
  },
};
</script>

<style scoped>
.titleText {
  white-space: nowrap;
  /* 确保文本在一行内显示 */
  overflow: hidden;
  /* 超出div范围的文本会被隐藏 */
  text-overflow: ellipsis;
  /* 超出部分显示为省略号 */
}

img {
  object-fit: cover;
}

body {
  width: 794px;
  height: 1123px;
  padding: 0;
  margin: 0;
  color: rgba(0, 0, 0, 0.6);
}
</style>
